import { isBoolean } from 'lodash';
import PropTypes from 'prop-types';
import Status from './status';
import connectionType from './connectionType';

const DiagnoseConnectionStep = ({ item, onNextClick, onPrevClick }) => {
  const disabled = !isBoolean(item.success_ping) || !isBoolean(item.success_connection);

  return (
    <>
      <div className="info">
        <div className="info-block">
          <div className="w-100">
            <div className="info-value">
              <span className="title-value">IP Address:Port</span>
              <span className="value">{`${item.host}:${item.port}`}</span>
            </div>
          </div>
          <div className="info-block w-100">
            <div className="info-value diagnose">
              <span className="title-value">Site:</span>
              <span className="value">{item.site_name || item.atg_site || 'N/a'}</span>
            </div>
            <div className="info-block diagnose">
              <div className="info-value connection">
                <span className="title-value">Ping:</span>
                <span className="value">
                  <Status status={item.success_ping} />
                </span>
              </div>
              <div className="info-value connection">
                <span className="title-value">Connection:</span>
                <span className="value">
                  <Status status={item.success_connection} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="connection-modal-footer buttons">
        <button type="button" className="protean-btn" onClick={onPrevClick}>
          Back
        </button>
        <button
          type="button"
          className="protean-btn protean-btn-default modal-btn"
          disabled={disabled}
          onClick={onNextClick}
        >
          Next
        </button>
      </div>
    </>
  );
};

DiagnoseConnectionStep.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  item: connectionType.isRequired
};

export default DiagnoseConnectionStep;
